module.exports = __webpack_public_path__ + "static/media/button.489b1b5b.png";